export default {"src":"/_next/static/media/no-data.a44a4bbf.svg","height":198,"width":226};